var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"artist-profile__empty-biography"},[_c('img',{staticStyle:{"width":"361px"},attrs:{"src":'/res7/img/placeholders/'+_vm.name_+'.svg',"alt":_vm.name}}),_vm._v(" "),(_vm.text_html)?_c('p',{staticClass:"artist-profile__empty-biography-text",domProps:{"innerHTML":_vm._s(_vm.text_html)}}):_vm._e(),_vm._v(" "),_vm._t("action")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5b6e0055","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/lib/placeholder8.vue
// module id = null
// module chunks = 